module.exports = __webpack_public_path__ + "static/media/iconEdit3.ab3160d2.svg";